import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClient } from "@angular/common/http";
import { CreateQuestionAnswerRequest, CreateAnswerScoreRequest } from '../model/faq.model'
import { CreateChatReqRes } from '../model/chat.model';
import { CONVERSATION_SERVICE, KNOWLEDGE_CHECK_SERVICE } from "./service-url";
@Injectable({
  providedIn: 'root'
})
export class FaqService {
 
  httpClient: any;

  constructor(private http: HttpClient) { }

  public getQuestionAnswer(request: CreateQuestionAnswerRequest):Observable<any> {
       return this.http.post(KNOWLEDGE_CHECK_SERVICE.generateQuestionAnswerPairs, request);
  }

   /** Get FAQ history by session id */
   public chatFaqHistoryList(sessionId:number): Observable<any> {
    if (sessionId) {
        return this.http.get(KNOWLEDGE_CHECK_SERVICE.faqHistoryBySessionId + '/' + sessionId);
    }
    else {
        return null;
    }
}

 /** Get FAQ Feedback  by session id */
  public getFaqFeedback(request: { chat_session_id:number}): Observable<any> {
    if (request) {
        return this.http.post(KNOWLEDGE_CHECK_SERVICE.faqFeedbackBySessionId, request);
    }
    else {
        return null;
    }
  }

  public createChatSession(request: CreateChatReqRes):Observable<any> {
    if (request) {
       return this.http.post(CONVERSATION_SERVICE.createChatSession, request);
    }
    else {
        return null;
    }
}
  public getAnswerScore(request: CreateAnswerScoreRequest):Observable<any> {
    if (request) {
      return this.http.post(KNOWLEDGE_CHECK_SERVICE.evaluateFaqResponse, request);
    }
    else {
        return null;
    }
  }
}
